import React, { Component, Fragment} from 'react';
import { connect } from 'react-redux';
import Slider from "react-slick";
import TruncateMarkup from 'react-truncate-markup';

const mapStateToProps = state => {
    return {
      banners: state.banners  
    }
}
  
const mapDispatchToProps = dispatch => {
    return {
  
    }
}
  
class Sliders extends Component {
    constructor(props){
        super(props);
        this.state = {
            num : 3
        }
    }
    updateDimensions() {
        var viewportWidth = window.innerWidth || document.documentElement.clientWidth;
        if(viewportWidth < 768){
            this.setState({num: 2})
        }else{
            this.setState({num: 3})
        }
    }
    componentDidMount() {
        this.updateDimensions();                  
        window.addEventListener("resize", this.updateDimensions.bind(this));
    }
    componentWillUnmount() {
        window.removeEventListener("resize", this.updateDimensions.bind(this));
    }
    render() {
        const settings = {
            dots: false,
            infinite: false,
            speed: 500,
            slidesToShow: 3,
            slidesToScroll: 1,
            responsive : [
                {
                    breakpoint: 1024,
                    settings: {
                      slidesToShow: 3,
                      slidesToScroll: 1,
                      infinite: false,
                      dots: true
                    }
                    
                },
                {
                breakpoint: 767,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            }]
          };
        let listBanners = [...this.props.banners].sort((min, max) => parseInt(min.displayOrder) - parseInt(max.displayOrder));
        let len = listBanners.length;
        let str = [];
        if(len < 3){
            for(let i = 0; i < this.state.num - len; i ++){
                str.push(<div className="item empty" key={i}>&nbsp;</div>)
            }
        }             
        return (
            <div className={`list-slider clearfix ${len > 2 ? 'has-slider' : ''}`}>
                {
                    <Slider {...settings}>
                        {
                            listBanners.map((e, i) => 
                            <div className="item" key={i}>
                                <div className="img" style={{backgroundImage: `url(${e.media.thumbnailURL})`}}></div>
                                <div className="name">   
                                {
                                    e.displayName !== '' ? <TruncateMarkup lines={2}><div>{e.displayName}</div></TruncateMarkup> : ''
                                }                               
                                
                                </div>
                            </div> 
                            )
                        }
                        {
                            str.map((e, i) => e)
                        }
                    </Slider>
                    
                }
            </div>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Sliders);